import * as yup from 'yup';
import { validateCpfCnpj } from '../../../shared/utils/functions';
import { translate } from '../../../shared/i18n';

export const schemaCreateUser = yup.object().shape({
  name: yup.string().required(translate('usersPage.validation.nameRequired')),
  cpf: yup
    .string()
    .required(translate('usersPage.validation.cpfRequired'))
    .test(
      'test-invalid-cpf',
      translate('usersPage.validation.invalidCpf'),
      (cpf) => validateCpfCnpj(cpf),
    ),
  phone: yup.string().required(translate('usersPage.validation.phoneRequired')),
  birthday: yup
    .string()
    .required(translate('usersPage.validation.birthDateRequired')),
  email: yup.string().required(translate('usersPage.validation.loginRequired')),
  access_group_id: yup
    .string()
    .required(translate('usersPage.validation.accessGroupRequired')),
  password: yup
    .string()
    .required(translate('usersPage.validation.passwordRequired')),
  confirmPassword: yup
    .string()
    .required(translate('usersPage.validation.passwordConfirmationRequired'))
    .oneOf(
      [yup.ref('password')],
      translate('usersPage.validation.passwordMismatch'),
    ),
});

export const schemaEditUser = yup.object().shape({
  name: yup.string().required(translate('usersPage.validation.nameRequired')),
  cpf: yup
    .string()
    .required(translate('usersPage.validation.cpfRequired'))
    .test(
      'test-invalid-cpf',
      translate('usersPage.validation.invalidCpf'),
      (cpf) => validateCpfCnpj(cpf),
    ),
  phone: yup.string().required(translate('usersPage.validation.phoneRequired')),
  birthday: yup
    .string()
    .required(translate('usersPage.validation.birthDateRequired')),
  email: yup.string().required(translate('usersPage.validation.loginRequired')),
  access_group_id: yup
    .string()
    .required(translate('usersPage.validation.accessGroupRequired')),
});
